import React, { useState, useEffect} from "react";
import { useAuth } from '../context/AuthContext'; // ✅ AGREGAR

import { Link, useNavigate } from "react-router-dom";
import Logo from "../components/Logo";
import WhatsAppFloating from "../components/WhatsAppFloating";

const HomePage = () => {
  const navigate = useNavigate();
    const { user, loading } = useAuth(); // ✅ AGREGAR

  const [query, setQuery] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);

  const API_ENDPOINTS = {
    giftSearchCouples: 'https://gift-searchcouple-336444799661.us-central1.run.app/giftSearchCouples',
  };

  const [searching, setSearching] = useState(false);

  // ✅ NUEVO: Redirigir si ya está logueado (OPCIONAL)
  useEffect(() => {
    if (!loading && user) {
      // console.log('👤 Usuario ya logueado en HomePage'); // ✅ DEBUG
      // Opcional: Descomentar si querés que redirija automáticamente
      if (user.role === 'admin') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/mi-cuenta', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  const handleSearch = async (e) => {
    e.preventDefault();

    const q = query.trim();
    if (!q) {
      alert('⚠️ Por favor ingresá los nombres que querés buscar');
      return;
    }

    // Sanitizar búsqueda
    const slug = q
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, "y")
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

    if (slug.length < 3) {
      alert('⚠️ Por favor ingresá al menos 3 caracteres');
      return;
    }

    setSearching(true);

    try {
      // Buscar parejas que coincidan
      const response = await fetch(
        `${API_ENDPOINTS.giftSearchCouples}?q=${encodeURIComponent(slug)}`
      );
      const data = await response.json();

      if (data.success) {
        if (data.count === 0) {
          // No se encontró ninguna lista → Mostrar página bonita
          navigate('/buscar-resultados', {
            state: {
              results: [],
              query: q
            }
          });
        } else if (data.count === 1) {
          // Una sola lista → ir directo
          navigate(`/lista/${data.results[0].id}`);
        } else {
          // Múltiples resultados → ir a página de resultados
          navigate('/buscar-resultados', {
            state: {
              results: data.results,
              query: q
            }
          });
        }
      } else {
        alert('❌ Error al buscar. Por favor intentá de nuevo.');
      }
    } catch (error) {
      console.error('Error searching:', error);
      // Fallback: intentar con el slug directo (comportamiento anterior)
      navigate(`/lista/${slug}`);
    } finally {
      setSearching(false);
    }
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-accent-50 via-white to-primary-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm shadow-sm border-b border-neutral-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <Logo className="h-12 sm:h-14" />

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center space-x-8">
              <button
                onClick={() => {
                  document.getElementById("como-funciona")?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }}
                className="text-neutral-600 hover:text-accent-600 transition-colors font-medium"
              >
                ¿Cómo funciona?
              </button>
              {/* <button
  onClick={() => {
    document
      .getElementById("buscar-lista")
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  }}
  className="text-neutral-600 hover:text-accent-600 transition-colors font-medium"
>
  Buscar Lista
</button> */}
              <Link
                to="/contacto"
                className="text-neutral-600 hover:text-accent-600 transition-colors font-medium"
              >
                Contacto
              </Link>
              <Link
                to="/login"
                className="text-accent-600 hover:text-accent-700 transition-colors font-medium"
              >
                Iniciar Sesión
              </Link>
              <Link to="/register" className="btn-primary text-sm">
                Registrarse
              </Link>
            </nav>

            {/* Mobile */}
            {/* <button className="md:hidden text-neutral-600" aria-label="Menu">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button> */}
            <button
              className="md:hidden text-neutral-600"
              aria-label="Menu"
              aria-expanded={mobileOpen}
              onClick={() => setMobileOpen((v) => !v)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>


      </header>
      {/* Mobile overlay menu */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-50">
          {/* Backdrop */}
          <button
            type="button"
            aria-label="Cerrar menu"
            onClick={() => setMobileOpen(false)}
            className="absolute inset-0 bg-black/40"
          />

          {/* Panel */}
          <div className="absolute top-0 left-0 right-0 bg-white shadow-xl border-b border-neutral-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
              <div className="flex items-center justify-between">
                <Logo className="h-12 sm:h-14" />
                <button
                  type="button"
                  aria-label="Cerrar"
                  onClick={() => setMobileOpen(false)}
                  className="text-neutral-700"
                >
                  ✕
                </button>
              </div>

              <nav className="mt-4 space-y-3 pb-3">
                <button
                  onClick={() => {
                    setMobileOpen(false);
                    document.getElementById("como-funciona")?.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                  className="block w-full text-left text-neutral-700 font-medium py-2"
                >
                  ¿Cómo funciona?
                </button>

                <button
                  onClick={() => {
                    setMobileOpen(false);
                    document.getElementById("buscar-lista")?.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }}
                  className="block w-full text-left text-neutral-700 font-medium py-2"
                >
                  Buscar Lista
                </button>

                <Link
                  to="/contacto"
                  onClick={() => setMobileOpen(false)}
                  className="block text-neutral-700 font-medium py-2"
                >
                  Contacto
                </Link>

                <Link
                  to="/login"
                  onClick={() => setMobileOpen(false)}
                  className="block text-accent-700 font-semibold py-2"
                >
                  Iniciar Sesión
                </Link>

                <Link
                  to="/register"
                  onClick={() => setMobileOpen(false)}
                  className="inline-block btn-primary text-sm mt-2"
                >
                  Registrarse
                </Link>
              </nav>
            </div>
          </div>
        </div>
      )}

      {/* Hero */}
      <section className="relative min-h-[650px] sm:h-[650px] flex items-start sm:items-center justify-center overflow-hidden py-10 sm:py-0">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1529636798458-92182e662485?w=1600&q=80"
            alt="Wedding"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/20" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl sm:text-6xl font-display font-bold mb-6 leading-tight">
            Tu lista de regalos, <span className="text-gold-200">sin vueltas</span>
          </h1>

          <p className="text-xl sm:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
            Elegís regalos simbólicos, tus invitados aportan y ustedes reciben el dinero directo.

          </p>

          {/* <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <Link to="/register" className="btn-primary text-lg px-10 py-4">
              Crear mi lista
            </Link>
            <Link
              to="/buscar"
              className="bg-white/10 border border-white/30 text-white px-10 py-4 rounded-lg font-semibold text-lg hover:bg-white/20 transition-all"
            >
              Buscar una lista
            </Link>
          </div> */}

      <form
  id="buscar-lista"
  onSubmit={handleSearch}
  className="mx-auto mt-6 max-w-2xl"
>
  {/* Search input con icono */}
  <div className="flex flex-col sm:flex-row items-stretch gap-3 bg-white/10 border border-white/20 rounded-2xl p-3 backdrop-blur-sm">
    <div className="relative flex-1">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 text-white/50">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Buscá: ‘Sofi y Nico’, Belén & Martín’, etc."
        className="w-full bg-transparent placeholder:text-white/60 text-white pl-12 pr-4 py-3 rounded-xl outline-none border border-white/10 focus:border-white/40 transition-colors"
      />
    </div>
    
    <button
      type="submit"
      disabled={searching}
      className="px-8 py-3 rounded-xl bg-white text-neutral-900 font-semibold hover:bg-gold-100 transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl"
    >
      {searching ? (
        <span className="flex items-center justify-center gap-2">
          <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Buscando...
        </span>
      ) : (
        'Buscar'
      )}
    </button>
  </div>

  {/* Helper text separado */}
  <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-x-2 gap-y-2 text-sm">
    <p className="text-white/75">
      O si preferís,{" "}
    </p>
    <Link
      to="/explorar"
      className="inline-flex items-center gap-1.5 text-white font-semibold hover:text-gold-200 transition-colors group"
    >
      <span className="underline decoration-white/30 group-hover:decoration-white">
        explorá todas las bodas
      </span>
      <svg className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </Link>
  </div>
</form>

          {/* reassurance pills */}
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center text-sm sm:text-base text-white/90">
            <div className="px-4 py-2 sm:px-5 sm:py-2.5 rounded-full bg-white/10 border border-white/15">
              Sin costos ocultos
            </div>
            <div className="px-4 py-2 sm:px-5 sm:py-2.5 rounded-full bg-white/10 border border-white/15">
              Simple para invitados
            </div>
            <div className="px-4 py-2 sm:px-5 sm:py-2.5 rounded-full bg-white/10 border border-white/15">
              Dinero directo a ustedes
            </div>
          </div>
        </div>
      </section>

      {/* Cómo funciona */}
<section   id="como-funciona" className="pt-10 pb-14 sm:pt-16 sm:pb-20 bg-gradient-to-b from-neutral-50 to-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

    {/* Header */}
    <div className="text-center mb-12 sm:mb-16">
      <h2  className="text-4xl sm:text-5xl font-display font-bold text-neutral-900 mb-4">
        ¿Cómo funciona?
      </h2>
      <p className="text-xl text-neutral-600">
        Un proceso simple, pensado para que fluya naturalmente.
      </p>
    </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
            <div>
              <span className="block text-sm uppercase tracking-widest text-neutral-400 mb-3">
                Paso 1
              </span>
              <h3 className="text-2xl font-display font-semibold mb-3">
                Creá tu lista
              </h3>
              <p className="text-neutral-600">
                Armá una galería de regalos simbólicos que representen lo que quieren para esta nueva etapa.
              </p>
            </div>

            <div className="relative">
              <span className="block text-sm uppercase tracking-widest text-neutral-400 mb-3">
                Paso 2
              </span>
              <h3 className="text-2xl font-display font-semibold mb-3">
                Compartí el link
              </h3>
              <p className="text-neutral-600">
                Enviá tu lista por WhatsApp, mail o redes. Los invitados acceden sin registrarse.
              </p>
            </div>

            <div>
              <span className="block text-sm uppercase tracking-widest text-neutral-400 mb-3">
                Paso 3
              </span>
              <h3 className="text-2xl font-display font-semibold mb-3">
                Recibí los regalos
              </h3>
              <p className="text-neutral-600">
                El dinero llega directo a ustedes para usarlo como quieran.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Este mes se casan */}
<section className="pt-10 pb-14 sm:pt-16 sm:pb-20 bg-gradient-to-b from-neutral-50 to-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
<div className="text-center mb-8 sm:mb-10">
            <h2 className="text-4xl sm:text-5xl font-display font-bold text-neutral-900 mb-4">
              Lo que nos dicen las parejas
            </h2>
            <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
              Testimonios de quienes eligieron una forma más simple de recibir regalos.
            </p>
          </div>

          {/* Testimonials */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                text: "Queríamos algo simple para nuestros invitados. SobreDigital fue exactamente eso.",
                author: "Paula & Roby",
                location: "Buenos Aires"
              },
              {
                text: "Nos evitó explicaciones incómodas y regalos repetidos.",
                author: "Lara & Mati",
                location: "Rosario"
              },
              {
                text: "A nuestros invitados les encantó la idea. Para nosotros fue un alivio total.",
                author: "Juli & Car",
                location: "Córdoba"
              }
            ].map((t, i) => (
              <div
                key={i}
                className="rounded-2xl p-8 bg-white border border-neutral-200 shadow-sm hover:shadow-lg transition-all"
              >
                <p className="text-neutral-700 text-lg leading-relaxed mb-6">
                  “{t.text}”
                </p>
                <div className="text-sm text-neutral-500">
                  — {t.author}, {t.location}
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-12 text-center">
            <Link to="/register" className="btn-primary inline-block px-10 py-4 text-lg">
              Crear mi lista
            </Link>
          </div>
        </div>
      </section>



      {/* Replacement benefits section */}
      <section className="pt-14 pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-display font-bold text-neutral-900 mb-4">
              Pensada para parejas, simple para invitados
            </h2>
            <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
              Una forma moderna de regalar sin caer en el “pasame el CBU”.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div className="rounded-2xl p-8 border border-neutral-200 bg-gradient-to-br from-neutral-50 to-white shadow-sm hover:shadow-xl transition-all">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="text-accent-700">
                  <path d="M7 7h10M7 12h10M7 17h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <h3 className="text-2xl font-display font-semibold text-neutral-900 mb-3">
                Sin vueltas
              </h3>
              <p className="text-neutral-600 leading-relaxed">
                La lista se ve como una galería de regalos. Tus invitados eligen, aportan y listo.
              </p>
            </div>

            <div className="rounded-2xl p-8 border border-neutral-200 bg-gradient-to-br from-neutral-50 to-white shadow-sm hover:shadow-xl transition-all">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="text-primary-700">
                  <path d="M12 3v18M3 12h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <h3 className="text-2xl font-display font-semibold text-neutral-900 mb-3">
                Regalos compartidos
              </h3>
              <p className="text-neutral-600 leading-relaxed">
                Varios invitados pueden sumarse y entre todos completan el regalo.
              </p>
            </div>

            <div className="rounded-2xl p-8 border border-neutral-200 bg-gradient-to-br from-neutral-50 to-white shadow-sm hover:shadow-xl transition-all">
              <div className="w-12 h-12 rounded-xl bg-gold-100 flex items-center justify-center mb-5">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="text-gold-700">
                  <path d="M7 10V8a5 5 0 0110 0v2M6 10h12v10H6V10z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="text-2xl font-display font-semibold text-neutral-900 mb-3">
                Ustedes reciben el regalo
              </h3>
              <p className="text-neutral-600 leading-relaxed">
                El aporte se transforma en dinero para que lo usen como quieran.
              </p>
            </div>
          </div>

          <div className="mt-10 text-center">
            <Link to="/register" className="btn-primary inline-block px-10 py-4 text-lg">
              Crear mi lista
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-r from-accent-500 to-primary-500 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl sm:text-5xl font-display font-bold mb-6">
            ¿Listo para crear tu lista?
          </h2>
          <p className="text-xl mb-8 text-white/90">
            Sumate a las parejas que ya eligieron una forma más simple de recibir regalos.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/register"
              className="bg-white text-accent-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gold-100 transition-all shadow-lg hover:shadow-xl"
            >
              Crear mi Lista Ahora
            </Link>
            {/* <Link
              to="/buscar"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-accent-600 transition-all"
            >
              Buscar una Lista
            </Link> */}
            <button
              onClick={() => {
                document
                  .getElementById("buscar-lista")
                  ?.scrollIntoView({ behavior: "smooth", block: "center" });
              }}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-accent-600 transition-all"
            >
              Buscar Lista
            </button>
          </div>
        </div>
      </section>

      {/* ✅ Footer (proper) */}
      <WhatsAppFloating />
      <footer className="bg-white border-t border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
            <div>
              <Logo className="h-10" />
              <p className="text-neutral-600 mt-3 max-w-sm">
                Una forma elegante de regalar a los novios: elegís un regalo simbólico y el dinero llega directo a ellos.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
              <div>
                <h4 className="font-semibold text-neutral-900 mb-3">Producto</h4>
                <ul className="space-y-2 text-neutral-600">
                  <li> <button
                    onClick={() => {
                      document.getElementById("como-funciona")?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }}
                    className="hover:text-accent-600"
                  >
                    ¿Cómo funciona?
                  </button></li>
                  <li><button
                    onClick={() => {
                      document
                        .getElementById("buscar-lista")
                        ?.scrollIntoView({ behavior: "smooth", block: "center" });
                    }}
                    className="hover:text-accent-600"
                  >
                    Buscar Lista
                  </button>
                  </li>
                  <li>
                    <Link to="/explorar" className="hover:text-accent-600">
                      Explorar Bodas
                    </Link>
                  </li>
                  <li><Link to="/contacto" className="hover:text-accent-600">Contacto</Link></li>


                  
                </ul>
              </div>

              <div>
                <h4 className="font-semibold text-neutral-900 mb-3">Cuenta</h4>
                <ul className="space-y-2 text-neutral-600">
                  <li><Link to="/login" className="hover:text-accent-600">Iniciar sesión</Link></li>
                  <li><Link to="/register" className="hover:text-accent-600">Registrarse</Link></li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold text-neutral-900 mb-3">Legal</h4>
                <ul className="space-y-2 text-neutral-600">
                  <li><Link to="/terminos" className="hover:text-accent-600">Términos</Link></li>
                  <li><Link to="/faq" className="hover:text-accent-600">Preguntas</Link></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-neutral-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-neutral-500">
              © {new Date().getFullYear()} SobreDigital. Todos los derechos reservados.
            </p>
            <p className="text-sm text-neutral-500">
              Hecho con 💛 en Argentina
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
